/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Firedefect1Inputs */



/**
* | output |
* | --- |
* | "Fire fault" |
*
* @param {Ahu_History_Key_Firedefect1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_firedefect1 = /** @type {((inputs?: Ahu_History_Key_Firedefect1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Firedefect1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Fire fault")
	return /** @type {LocalizedString} */ ("Défaut incendie")
});
export { ahu_history_key_firedefect1 as "ahu_history_key_fireDefect" }